<div class="main-content table-page table-page--compact table-page--dense historial-solser-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Registro de Acceso de Personal</h1>
        <p>Consulte y ajuste los accesos del día para el personal activo de Solser.</p>
      </div>
      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="agregarHorasHistorial()">
          <span class="material-icons">add</span>
          Agregar Registro
        </button>
      </div>
    </section>

    <section class="table-page__card">
      <form [formGroup]="formFiltros" class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--wide">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Buscar por nombre</mat-label>
              <input matInput aria-label="Buscar por nombre" maxlength="120" formControlName="nombreEmpleado" />
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--narrow">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Fecha</mat-label>
              <input matInput aria-label="Fecha" [matDatepicker]="picker0" readonly formControlName="fechaFiltro" />
              <mat-datepicker-toggle matIconSuffix [for]="picker0"></mat-datepicker-toggle>
              <mat-datepicker #picker0></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="historial-solser-page__day">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                  title="Día anterior" aria-label="Día anterior" (click)="diaAntes()">
            <span class="material-icons">chevron_left</span>
            Anterior
          </button>
          <div class="historial-solser-page__day-copy">
            <span class="historial-solser-page__day-label">Registros del día</span>
            <strong class="historial-solser-page__day-value">{{ Fechad }}</strong>
          </div>
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                  title="Día siguiente" aria-label="Día siguiente" (click)="diaDespues()">
            Siguiente
            <span class="material-icons">chevron_right</span>
          </button>
        </div>

        <div class="table-page__toolbar-actions">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="limpiarFiltros()">
            <span class="material-icons">filter_alt_off</span>
            Limpiar
          </button>
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="exportAsXLSX()" [matTooltip]="tittleD">
            <span class="material-icons">download</span>
            Exportar
          </button>
        </div>
      </form>

      <div class="table-page__table-wrap">
        <table class="table-page__table" *ngIf="HistorialEmpl.length > 0; else historialEmptyState">
          <thead>
            <tr>
              <th>Empleado</th>
              <th>Entrada</th>
              <th>Salida</th>
              <th>Ubicación</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let empleadoBean of HistorialEmpl">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ empleadoBean.nombre }}</strong>
                  <span class="table-page__subtext">Acceso registrado</span>
                </div>
              </td>
              <td><span class="table-page__text">{{ empleadoBean.entrada | date : 'h:mm a' }}</span></td>
              <td><span class="table-page__text">{{ empleadoBean.salida | date : 'h:mm a' }}</span></td>
              <td><span class="table-page__text">{{ empleadoBean.ubicacion }}</span></td>
              <td class="table-page__actions">
                <button type="button" class="table-page__action-btn" aria-label="Editar" (click)="editarEmpleadoHistorial(empleadoBean)" matTooltip="Editar">
                  <span class="material-icons">edit</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #historialEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else historialLoadingState">
            <i class="material-icons">badge</i>
            <strong>No se encontraron registros de acceso</strong>
            <span>Pruebe con otro nombre o cambie la fecha del historial.</span>
          </div>
        </ng-template>

        <ng-template #historialLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando registros de acceso...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ (currentPage - 1) * pageSize + 1 }} a {{ rangeEnd }} de {{ totalRegistrosH }} registros</span>
          <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>
        </div>

        <nav class="table-page__pager" aria-label="Paginación" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" title="Primera página" aria-label="Primera página"
                  (click)="firstPage()" [disabled]="currentPage === 1">
            <span class="material-icons">first_page</span>
          </button>
          <button type="button" class="table-page__pager-link" title="Página anterior" aria-label="Página anterior"
                  (click)="previousPage()" [disabled]="currentPage === 1">
            <span class="material-icons">chevron_left</span>
          </button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button *ngIf="isPageNumber(item); else historialPagerEllipsis" type="button" class="table-page__pager-page" [class.is-current]="item === currentPage" (click)="onPageChange(item)">
              {{ item }}
            </button>
            <ng-template #historialPagerEllipsis>
              <span class="table-page__pager-ellipsis">…</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" title="Página siguiente" aria-label="Página siguiente"
                  (click)="nextPage()" [disabled]="currentPage === totalPages">
            <span class="material-icons">chevron_right</span>
          </button>
          <button type="button" class="table-page__pager-link" title="Última página" aria-label="Última página"
                  (click)="lastPage()" [disabled]="currentPage === totalPages">
            <span class="material-icons">last_page</span>
          </button>
        </nav>

        <label class="table-page__page-size">
          <span>Ver:</span>
          <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
            <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
      </div>
    </section>
  </div>
</div>
